module.exports = __webpack_public_path__ + "static/img/南工.2942e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/南工.jpg
// module id = I4x6
// module chunks = 1